export { default } from './CookieConsent';
